<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
 export default {
  name: 'quickCutPage',
  data() {
      return {

      }
  },
  methods: {

  },

} 
</script>
